import { render, staticRenderFns } from "./happiness-selector.component.vue?vue&type=template&id=ff8809f6&scoped=true&"
import script from "./happiness-selector.component.vue?vue&type=script&lang=ts&"
export * from "./happiness-selector.component.vue?vue&type=script&lang=ts&"
import style0 from "./happiness-selector.component.vue?vue&type=style&index=0&id=ff8809f6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8809f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
